import React from 'react';
import { cn } from '../../lib/utils';
import { Loader2 } from 'lucide-react';

interface SpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
    label?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className, label }) => {
    const sizes = {
        sm: 'w-4 h-4',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
    };

    return (
        <div className={cn('flex flex-col items-center justify-center gap-2', className)}>
            <Loader2 className={cn(sizes[size], 'animate-spin text-primary-500')} />
            {label && <span className="text-sm text-surface-600">{label}</span>}
        </div>
    );
};

interface LoadingOverlayProps {
    visible: boolean;
    label?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ visible, label }) => {
    if (!visible) return null;

    return (
        <div className="absolute inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center animate-fade-in">
            <div className="flex flex-col items-center gap-3 p-6 rounded-2xl bg-white shadow-glass">
                <div className="relative">
                    <div className="w-12 h-12 rounded-full border-4 border-primary-100 animate-pulse" />
                    <Loader2 className="w-8 h-8 text-primary-500 animate-spin absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
                </div>
                {label && <span className="text-sm font-medium text-surface-700">{label}</span>}
            </div>
        </div>
    );
};
